import type { Handleiding } from './soort';

export const ko: Handleiding = {
  code: 'ko',
  titel: '사용 설명서',
  inleiding: 'Ask Gio Tolk은 서로 말이 통하지 않는 두 사람의 대화를 통역해 줘. 아래에 각 버튼이 무엇을 하는지 적어 놨어.',
  knop: '사용 설명서 열기',
  sluiten: '닫기',
  groepGebruik: '대화 참여하기',
  groepBeheer: '설정과 관리',
  delen: [
    {
      titel: '말하기',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '말해 봐',
          uitleg: '한 번 눌러서 시작해. 1초 조금 넘게 조용히 있으면 녹음이 저절로 멈추고, 한 번 더 누르면 멈춰. 1분이 지나면 어차피 멈춰.',
        },
        {
          kop: '한 번에 하나의 소리만',
          uitleg:
            '앱이 말하는 동안에는 녹음할 수 없어. 그리고 네가 녹음하는 동안에는 들어온 번역이 네가 끝낼 때까지 기다려. 안 그러면 마이크가 앱 소리를 녹음해서 네가 말한 걸로 착각하거든.',
        },
        {
          kop: '여기에 메시지를 입력해',
          uitleg: '말하기와 나란히 쓸 수 있고 같은 번역을 거쳐. 엔터로 보내고, 시프트와 엔터로 줄을 바꿔.',
        },
        {
          kop: '고칠 시간',
          uitleg: '받아쓴 문장을 보내기 전에 다시 읽을 시간을 몇 초로 할지 여기서 정해. 0으로 하면 바로 나가.',
        },
        {
          kop: '항상 직접 확인하고 보내기',
          uitleg: '더 이상 시계는 없어. 모든 문장이 네가 보내기를 누를 때까지 기다려. 문장마다 확인하고 싶은 사람을 위한 설정이야.',
        },
        {
          kop: '번역을 바로 재생',
          uitleg: '켜져 있어. 먼저 읽고 언제 들을지 직접 정하고 싶으면 꺼.',
        },
      ],
    },
    {
      titel: '메시지 읽기',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '크게 나오는 것',
          uitleg: '네 언어로 된 것이 크게 나와. 네 문장에서는 그게 원래 텍스트라서, 앱이 잘 알아들었는지 확인할 수 있어. 상대의 문장에서는 번역이야.',
        },
        {
          kop: '원문이나 번역 펼치기',
          uitleg: '다른 언어는 아래에 접혀 있어. 그 줄을 누르면 열려.',
        },
        {
          kop: '작은 삼각형',
          uitleg: '번역을 다시 재생해.',
        },
        {
          kop: '말하는 얼굴',
          uitleg: '상대방 본인의 녹음을 재생해. 말한 메시지에서만, 그리고 「네 목소리도 같이 보내기」가 켜져 있을 때만 나와. 입력한 메시지에는 녹음이 없어.',
        },
      ],
    },
    {
      titel: '화면 위쪽 버튼',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: '빼기와 더하기',
          uitleg: '글자를 작게 하거나 크게 해. 다섯 단계이고, 설정은 저장돼.',
        },
        {
          kop: '마이크',
          uitleg: '어차피 입력만 한다면 말하기 버튼을 숨겨. 자리를 아낄 수 있어.',
        },
        {
          kop: '키보드',
          uitleg: '입력창을 숨겨. 둘 중 하나는 항상 켜져 있어. 안 그러면 아무 말도 못 하게 되니까.',
        },
      ],
    },
    {
      titel: '들어오기',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: '어떤 말을 하니',
          uitleg: '이 선택이 버튼과 안내문의 언어도 정해. 그래서 둘이 서로 다른 화면을 보게 되는데, 그게 의도한 거야.',
        },
        {
          kop: '번역에서의 네 목소리',
          uitleg: '남자 목소리로 들릴지 여자 목소리로 들릴지 골라. 이건 방이 아니라 너에게 속한 설정이야. 참가자가 각자 따로 골라.',
        },
        {
          kop: '마이크 권한',
          uitleg: '들어올 때 브라우저가 물어봐. 거절해도 입력은 할 수 있어. 나중에 주소창의 자물쇠에서 권한을 줄 수도 있어.',
        },
      ],
    },
    {
      titel: '아래쪽, 접힌 부분',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: '예비 단어 목록',
          uitleg: '항상 같은 방식으로 번역해야 하는 말: 이름, 전문 용어, 상표. 방 전체에 적용돼.',
        },
        {
          kop: '설정 바꾸기',
          uitleg: '언어, 목소리, 말투, 맞춤법 교정은 대화 도중에도 바꿀 수 있어. 여기서 바꾼 건 바로 둘 다에게 적용돼.',
        },
      ],
    },
    {
      titel: '대화 시작하기',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: '대화 이름',
          uitleg: '비워 둬도 돼. 네 화면 위쪽에만 보여서, 누구와 이야기하는지 알 수 있게 해 줘.',
        },
        {
          kop: '화자 1과 화자 2',
          uitleg: '이 대화의 두 언어. 먼저 들어온 사람이 첫 자리를 차지해. 언어는 나중에 서로 바꿀 수도 있어.',
        },
        {
          kop: '번역의 말투',
          uitleg:
            '왼쪽에서 반말로 할지 존댓말로 할지 고르고, 오른쪽에서 분위기를 골라: 중립, 친근, 업무, 공식, 연인. 지시가 없으면 모델은 거의 항상 격식 있는 형태를 골라서, 평범한 대화에서는 거리감 있게 들려.',
        },
        {
          kop: '네 목소리도 같이 보내기',
          uitleg: '상대는 번역과 함께 네 녹음도 들을 수 있어. 언어를 배울 때 편해. 민감한 대화에서는 꺼 둬: 녹음을 받은 사람은 그걸 보관할 수 있으니까.',
        },
        {
          kop: '네 텍스트의 맞춤법 고치기',
          uitleg:
            '켜져 있어. 모델이 실제로 무엇을 알아들었는지 보려면 꺼. 그때 이상한 문장이 나오면, 잘못 알아들은 건지 제대로 알아듣고 다듬은 건지 알 수 있어.',
        },
        {
          kop: 'PIN 번호 사용',
          uitleg: '번호는 말로 알려 주고, 링크와 같은 메시지에 넣지 마. 전달된 링크로부터 지켜 줘.',
        },
        {
          kop: 'QR 코드',
          uitleg: '상대에게 스캔하게 하거나 링크를 보내. 방은 네 시간 뒤에 저절로 만료돼.',
        },
      ],
    },
    {
      titel: '네 대화는 어떻게 되나',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: '텍스트는 저장되지 않아',
          uitleg: '너희가 한 말은 데이터베이스에 들어가지 않아. 비용 때문에 언제 얼마나 이야기했는지만 남아.',
        },
        {
          kop: '녹음은 저절로 사라져',
          uitleg: '오디오는 메모리에 10분 남아 있다가 사라져.',
        },
        {
          kop: '방은 만료돼',
          uitleg: '만든 지 네 시간 뒤에. 그다음에는 링크가 더 이상 작동하지 않아.',
        },
        {
          kop: '예산이 있어',
          uitleg: '방마다, 그리고 달마다. 다 차면 앱이 번역을 멈추고 그렇게 알려 줘. 고장이 아니야.',
        },
      ],
    },
  ],
};
